var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejsStackedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 164,
    viewBox: "0 0 289 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_7900)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_337_7900",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 289,
    height: 177,
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289 0H0v177h289V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_337_7900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.802 177c-.98 0-1.895-.261-2.744-.719l-8.688-5.161c-1.307-.719-.653-.98-.262-1.111 1.764-.588 2.091-.719 3.92-1.764.196-.131.457-.066.653.065l6.663 3.986c.262.13.588.13.784 0l26.065-15.093c.262-.131.392-.392.392-.719v-30.121c0-.326-.13-.588-.392-.718l-26.065-15.028c-.261-.131-.588-.131-.784 0l-26.064 15.028c-.262.13-.392.457-.392.718v30.121c0 .261.13.588.392.719l7.12 4.116c3.854 1.96 6.271-.327 6.271-2.614v-29.728c0-.392.327-.784.784-.784h3.332c.392 0 .784.326.784.784v29.728c0 5.162-2.809 8.168-7.709 8.168-1.502 0-2.678 0-6.01-1.634l-6.859-3.92a5.515 5.515 0 0 1-2.743-4.77v-30.12a5.514 5.514 0 0 1 2.743-4.77l26.065-15.093c1.633-.915 3.854-.915 5.487 0l26.065 15.093a5.513 5.513 0 0 1 2.744 4.77v30.12c0 1.96-1.045 3.79-2.744 4.77l-26.065 15.093c-.784.327-1.763.588-2.743.588Z",
    fill: "#5FA04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.902 156.288c-11.432 0-13.784-5.227-13.784-9.67 0-.392.327-.784.784-.784h3.397c.392 0 .719.261.719.653.522 3.463 2.025 5.162 8.949 5.162 5.488 0 7.839-1.241 7.839-4.182 0-1.698-.653-2.94-9.211-3.789-7.12-.719-11.562-2.287-11.562-7.971 0-5.293 4.442-8.429 11.889-8.429 8.362 0 12.477 2.875 13 9.147 0 .196-.066.392-.196.588-.131.131-.327.262-.523.262h-3.462a.767.767 0 0 1-.719-.588c-.784-3.594-2.809-4.77-8.165-4.77-6.01 0-6.729 2.091-6.729 3.659 0 1.895.849 2.483 8.95 3.528 8.035 1.045 11.824 2.548 11.824 8.167 0 5.75-4.769 9.017-13 9.017ZM188.529 124.664c0 2.745-2.286 5.031-5.03 5.031-2.743 0-5.03-2.221-5.03-5.031 0-2.874 2.352-5.031 5.03-5.031 2.679 0 5.03 2.222 5.03 5.031Zm-9.276 0c0 2.353 1.895 4.247 4.181 4.247 2.352 0 4.246-1.96 4.246-4.247 0-2.352-1.894-4.181-4.246-4.181-2.221 0-4.181 1.829-4.181 4.181Zm2.352-2.809h1.96c.653 0 1.959 0 1.959 1.503 0 1.045-.653 1.241-1.045 1.372.784.065.849.588.915 1.307.065.457.13 1.241.261 1.502h-1.176c0-.261-.196-1.698-.196-1.764-.065-.326-.196-.457-.588-.457h-.98v2.287h-1.11v-5.75Zm1.045 2.483h.849c.719 0 .85-.523.85-.784 0-.784-.523-.784-.85-.784h-.914v1.568h.065Z",
    fill: "#5FA04E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.994 59.196a3.324 3.324 0 0 0-1.699-2.875L32.663 40.313c-.457-.26-.98-.392-1.503-.457H30.9c-.523 0-1.045.196-1.503.457L1.698 56.256A3.35 3.35 0 0 0 0 59.196l.065 42.862c0 .588.327 1.176.85 1.437.522.327 1.175.327 1.633 0l16.462-9.409a3.324 3.324 0 0 0 1.698-2.874v-20.06c0-1.175.653-2.286 1.699-2.874l6.99-4.051c.522-.327 1.11-.457 1.698-.457.588 0 1.176.13 1.633.457l6.99 4.051a3.324 3.324 0 0 1 1.698 2.875V91.21c0 1.177.654 2.287 1.699 2.875l16.331 9.409a1.593 1.593 0 0 0 1.699 0c.522-.261.849-.849.849-1.437V59.196ZM195.127.196c-.522-.261-1.176-.261-1.633 0-.522.327-.849.85-.849 1.437v42.47c0 .392-.196.784-.588 1.045a1.25 1.25 0 0 1-1.176 0l-6.924-3.985a3.367 3.367 0 0 0-3.332 0L152.927 57.17a3.325 3.325 0 0 0-1.698 2.874v31.95c0 1.177.653 2.287 1.698 2.875l27.698 16.008a3.367 3.367 0 0 0 3.332 0l27.698-16.008a3.324 3.324 0 0 0 1.698-2.874V12.349a3.35 3.35 0 0 0-1.698-2.94L195.127.196Zm-2.547 81.28c0 .327-.131.588-.392.719l-9.473 5.488a.968.968 0 0 1-.849 0l-9.472-5.488c-.261-.13-.392-.457-.392-.719V70.5c0-.326.131-.588.392-.718l9.472-5.489a.968.968 0 0 1 .849 0l9.473 5.489c.261.13.392.457.392.718v10.977ZM287.301 70.238c1.046-.588 1.634-1.699 1.634-2.875v-7.775a3.404 3.404 0 0 0-1.634-2.875l-27.502-15.942a3.365 3.365 0 0 0-3.331 0L228.77 56.779a3.325 3.325 0 0 0-1.699 2.874v31.95c0 1.177.654 2.287 1.699 2.875l27.502 15.681c1.045.589 2.286.589 3.266 0l16.658-9.277c.523-.262.849-.85.849-1.438s-.326-1.176-.849-1.437l-27.829-16.008c-.522-.327-.849-.85-.849-1.438v-9.996c0-.588.327-1.176.849-1.438l8.689-4.965a1.593 1.593 0 0 1 1.698 0l8.688 4.965c.523.327.85.85.85 1.438v7.84c0 .588.326 1.176.849 1.438a1.594 1.594 0 0 0 1.698 0l16.462-9.605Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.709 68.735a.593.593 0 0 1 .653 0l5.291 3.071c.196.13.327.327.327.588v6.142a.686.686 0 0 1-.327.588l-5.291 3.07a.593.593 0 0 1-.653 0l-5.292-3.07a.685.685 0 0 1-.326-.588v-6.142c0-.261.13-.457.326-.588l5.292-3.07Z",
    fill: "#5FA04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31 40.901a3.367 3.367 0 0 0-3.332 0L77.476 56.778c-1.045.589-1.633 1.7-1.633 2.875v31.82c0 1.176.653 2.287 1.633 2.875l27.502 15.877a3.367 3.367 0 0 0 3.332 0l27.502-15.877c1.045-.588 1.633-1.7 1.633-2.875v-31.82a3.406 3.406 0 0 0-1.633-2.874L108.31 40.9Z",
    fill: "url(#paint0_linear_337_7900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.877 56.779 108.244 40.9a4.543 4.543 0 0 0-.849-.326L76.5 93.5c.261.327.673.804 1 1l27.478 15.725c.784.457 1.698.588 2.548.326l29.069-53.184a2.044 2.044 0 0 0-.718-.588Z",
    fill: "url(#paint1_linear_337_7900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.063 35.086-.392.196h.523l-.131-.196Z",
    fill: "url(#paint2_linear_337_7900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.809 94.348c.784-.458 1.491-1.315 1.491-2.348l-30.104-51.49c-.784-.131-1.633-.066-2.352.391L77.408 56.713 107 110.682a4.54 4.54 0 0 0 1.241-.392l27.568-15.942Z",
    fill: "url(#paint3_linear_337_7900)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_7900",
    x1: 117.844,
    y1: 52.726,
    x2: 92.971,
    y2: 103.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3F8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#3E9638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#3DA92E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DAE2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_337_7900",
    x1: 102.464,
    y1: 79.278,
    x2: 172.246,
    y2: 27.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#3F873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#52A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#64B749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#6ABF4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_337_7900",
    x1: 74.834,
    y1: 35.163,
    x2: 138.473,
    y2: 35.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6ABF4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#64B749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#52A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#3F873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_337_7900",
    x1: 74.835,
    y1: 75.553,
    x2: 138.473,
    y2: 75.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6ABF4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#64B749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#52A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#3F873F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_7900"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h289v177H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsStackedDark);
export default __webpack_public_path__ + "static/media/nodejsStackedDark.7b6b4403922ac0550a6c40010c18dd52.svg";
export { ForwardRef as ReactComponent };